import React from "react";
import CustomerDeck from './CustomerDeck';
import PartnerDeck from './PartnerDeck';
import NullDeck from './NullDeck';
import axios from 'axios';

export default class DefaultDeck extends React.Component {
  state = {
    loading: true
  }

  componentDidMount() {
    const token = this.props.location.pathname.split('/')[1];
    if (!token) {
      this.setState({ loading: false });
    }
    axios.get(`https://request-slide-token.netlify.com/.netlify/functions/validateToken?token=${token}`)
      .then(res => {
        this.setState({ loading: false, result: res.data });
      })
      .catch((error) => {
        this.setState({ loading: false });
      });
  }

  render() {
    if (this.state.loading) {
      return null;
    }
    if (!this.state.result || !this.state.result.deckId) {
      return <NullDeck />;
    }
    return this.state.result.deckId === "125122ea-b53d-46ff-8f76-ff2335a6bf47" ? <PartnerDeck /> : <CustomerDeck />;
  }
}



// WEBPACK FOOTER //
// ./src/DefaultDeck.js